import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import ApolloLanguageService from '../../../../Services/ApolloLanguageService';

// Language dropdown whose value is a locale tag, from the ApolloLanguage lookup
export default class ApolloLanguageLocaleSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    showSelectFilterAt: 10,
    IsCheckBoxEnabled: false,
    editedItem: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    ApolloLanguageService.GetApolloLanguageLocales()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        (result ?? []).forEach((language) => {
          optValues.push({
            label: `${language.name} (${language.locale})`,
            value: language.locale,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('ALLS45');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        selectValues={this.state.selectValues}
        filterCleared={this.props.filterCleared}
        showSelectFilterAt={this.props.showSelectFilterAt}
        IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
        editedItem={this.props.editedItem}
      />
    );
  }
}
